/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconCloudWarning/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function TysiaIconCloudWarning({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconCloudWarning",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 20,
  height = 20,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#911011"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconCloudWarning.Svg"
  data-view-path={viewPath}
 viewBox="0 0 20 20"
 style={{'--as-1-29CpaO': alignSelf,'--mt-2-29CpaO': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-29CpaO': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-29CpaO': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-29CpaO': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-29CpaO': opacity,'--w-10-29CpaO': typeof width === 'number' ? `${width}px` : width,'--h-11-29CpaO': typeof height === 'number' ? `${height}px` : height,'--f-12-29CpaO': fill,'--a-7-29CpaO': isAnimated ? animation : "none",'--sd-8-29CpaO': isAnimated ? strokeDashoffset : 0,'--sd-9-29CpaO': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconCloudWarning.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M10.886 3.032a4.377 4.377 0 00-4.592 2.723 3.7 3.7 0 00.637 7.37h1.066V10.14a2.004 2.004 0 114.008 0v2.986H13.785a3.238 3.238 0 00.912-6.338 4.377 4.377 0 00-3.81-3.756zm-.885 6.356c.415 0 .752.337.752.752v3.507a.752.752 0 01-1.503 0V10.14c0-.415.336-.752.751-.752zm1.002 6.61a1.002 1.002 0 11-2.004 0 1.002 1.002 0 012.004 0z"
 style={{'--f-12-29CpaO': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}